import {Injectable} from '@angular/core';
import {ISignatureInfo} from '../pages/pdf-view/pdf-view.page';

export interface IDocument {
  doc: Blob;
  name: string;
  signatures: ISignatureInfo[];
}

@Injectable({
  providedIn: 'root'
})
export class PdfManagerService {
  private currentDocument: IDocument = null;

  constructor() {
  }

  public registerDocument(doc: IDocument) {
    this.currentDocument = doc;
  }

  public getRegisteredDocument(): IDocument {
    return this.currentDocument;
  }

  public clearRegisteredDocument() {
    this.currentDocument = null;
  }
}
